import React, { useEffect } from 'react';
import { LaptopOutlined, NotificationOutlined, UserOutlined } from '@ant-design/icons';
import type { MenuProps } from 'antd';
import { useList, useSelect } from '@refinedev/core';
import { PlayCircleFilled, EditFilled, PlusSquareFilled } from '@ant-design/icons';

import { Breadcrumb, Layout, Menu, theme, Modal } from 'antd';
import { CrudFilters, Option } from '@refinedev/core/dist/interfaces';
// import { PlayCircleFilled } from '@ant-design/icons';
import useState from 'react';
import { isArray } from 'util';
import Cw8List from 'components/cw8/Cw8List';
import { ConfigCard } from 'interfaces/schemaDB';
import Cw8Edit from 'components/cw8/Cw8Edit';
import { useSchemaDB } from 'hooks/useSchemaDB';
import EditSubseccion from './editSubseccion';
import Cw8Create from 'components/cw8/Cw8Create';
import { useModal, useModalForm } from '@refinedev/antd';
// import { SubsectionPubsCreate } from 'src/pages/subsectionpubs/create';
// import EditSubseccion from 'src/pages/infografias/editSubseccion';
const { Header, Content, Footer, Sider } = Layout;


interface ICategory {
  id: number;
  sec_nombre: string;
}

interface ISubCategory {
  id: string;
  sub_id_seccion : string;
  sub_nombre: string;
}

interface ItemMenu{
  key: string
  label: string
  icon?: JSX.Element
  children?: ItemMenu[] 
  type?: string
}

interface SeccionInfografiaProps{
  idInfografia: number;
  setSeccion?: (id: number) => void
}

const configCard : ConfigCard = {
  fieldTitle : "sld_nombre", 
  fieldDesc : "sld_nombre",
  fieldImg : ""
}

export function MenuSeccion({idInfografia, setSeccion}: SeccionInfografiaProps) {

  const prefijoCreateSubSeccion = 'create-sub-';
  const prefijoEditSeccion = 'edit-sec-';

  const { token: { colorBgContainer }, } = theme.useToken();
  const [itemsMenu, setItemsMenu] = React.useState<ItemMenu[]>([])
  const [secciones, setSecciones] = React.useState<string[]>([])
  const [idSubSection, setIdSubSection] = React.useState<string>()
  const [idSection, setIdSection] = React.useState<string>()
  const [openCreateModal, setOpenCreateModal] = React.useState(false);


  const { queryResult, options: optionsSections } = useSelect<ICategory>({
    resource: "seccionInfografia",
    optionLabel: "sec_nombre",
    optionValue: "id" 
   , filters : [
      {
          field: "sec_id_infografia",
          operator: "eq",
          value: idInfografia
      }
    ]
  });


  const { data : subSeccionesData } = useList<ISubCategory>({
    resource: "subSeccionInfografia"
    , pagination: {
      pageSize: 100,
    }
    , filters : [
        {
          field: "sub_id_seccion",
          operator: "eq",
          value: secciones
        }
      ]
    });
  
  
    //crear los items del menu
    useEffect(() => {

      const subSeccionesAll = subSeccionesData?.data ?? [];
      const seccionesMenu:ItemMenu[] = optionsSections?optionsSections.map((option, index) => ({
        key: option.value,
        icon: <PlayCircleFilled/>, 
        label: option.label,
        children : [] 
      })):[]
  
      const sectionWithSubsection = seccionesMenu.map((section) =>{
        const children: ItemMenu[]  = [{
          key : `${prefijoEditSeccion}${section.key}`,
          label : '- Editar SubSección'
          , icon: <EditFilled />
        }
        ,{
          key: `${prefijoCreateSubSeccion}${section.key}`,
          label: '+ Crear SubSección'
          , icon: <PlusSquareFilled />
        }
        , {
          key: '-',
          label: '',
          type: 'divider'
        }];

        subSeccionesAll.forEach((subsection) => {
          if(subsection.sub_id_seccion === section.key){
            children.push({
              key : `${subsection.id}`,
              label : subsection.sub_nombre
            })
          }
        })
  
        return {
          ...section,
          children
        }
      })
  
      const seccionesTmp : string[] = optionsSections?optionsSections.map((option, index) => (option.value)):[]
      setSecciones([seccionesTmp.join("|")])
      setItemsMenu( sectionWithSubsection )
    }, [optionsSections, subSeccionesData])



  // const menuClick: MenuProps['onClick'] = ( { item, key, keyPath, domEvent } ) => {
  //   const subSectionId = parseInt(`${key}`);
  //   if(subSectionId){
  //     setIdSubSection(subSectionId.toString());
  //   }else{
  //     const idSectionTemp = key.replace(prefijoCreateSubSeccion,'');
  //     setIdSection(idSectionTemp);
  //   }
  // }

  //---------------------------------------------
  // CLICK EN EL MENÚ LATERAL
  //---------------------------------------------
  const menuClick: MenuProps['onClick'] = ({ item, key, keyPath, domEvent }) => {
    console.log(key);
    const subSectionId = parseInt(`${key}`);

    //si es un numero es editar una subsección
    if (subSectionId) {
      console.log("New Subsection ", subSectionId.toString())
      setIdSubSection(subSectionId.toString());
    } else {
      //crear una subsección
      if (key.indexOf(prefijoCreateSubSeccion) >= 0) {
        const idSectionTemp = key.replace(prefijoCreateSubSeccion, '');
        console.log("New Section ", idSectionTemp)
        setIdSection(idSectionTemp);
      } else {
        //editar una seccion
        const idSectionTemp = key.replace(prefijoEditSeccion, '');
        console.log("Edit Section ", idSectionTemp)
        editModalShow(idSectionTemp)
        // console.log("Edit Section ", idSectionTemp)
        // setIdSection(idSectionTemp);

      }

    }
  }


  useEffect(() => {
    if (idSection) {
      createModalShow()
    }
  }, [idSection])


  const {
    // close : closeModal,
    modalProps: createModalProps,
    formProps: createFormProps,
    show: createModalShow
  } = useModalForm({
    // } = useModal({
    action: "create"
    , resource: 'subSeccionInfografia'
    , redirect: false
    // , warnWhenUnsavedChanges: true
    // , autoResetForm : true 
  });

  // const cerrarModal = () => {
  //   setOpenCreateModal(false)
  // }


  const {
    modalProps: editModalProps,
    formProps: editFormProps,
    show: editModalShow,
} = useModalForm({
    action: "edit"
    , resource: 'seccionInfografia'
    , redirect: false
});

  return (
    <>
        <Layout 
          style={{  background: colorBgContainer }} hasSider
        >
          <Sider  
          width={250}
            style={{
              background: colorBgContainer,
              }}          
          >
            <Menu
              mode="vertical"
              defaultSelectedKeys={[]}
              // defaultOpenKeys={['29','230', '28']}
              style={{ height: '100%' }}
              items={itemsMenu}
              onClick = {menuClick}
            />
          </Sider>

          <Content style={{ padding: '0 24px', minHeight: 280 }}>
              <EditSubseccion
                idSubseccion = {idSubSection}
                idSection={idSection} 
              ></EditSubseccion>
          </Content>
        </Layout>

        {
        <Modal {...createModalProps} 
          // open={openCreateModal} 
          // onCancel={ ()=> setOpenCreateModal(false) } 
          // key={idSection} 
          // destroyOnClose={true}
          // width={1000}
          // footer={[
          // ]}        
          title="Create Subsección infografía"
        >
            <Cw8Create
                key={idSection}
                resourceName = {'subSeccionInfografia'}
                filterList={[
                  {
                      field: "sub_id_seccion",
                      operator: "eq",
                      value: idSection
                  },
                ]}
              createFormProps={createFormProps}
                // isModal = {true}
                // closeModal={cerrarModal}
            ></Cw8Create>
        </Modal>
        }
        
        <Modal {...editModalProps}
                title="Editar Subsección"
            >
                <Cw8Edit
                    key={idSection}
                    resourceName={'seccionInfografia'}
                    editFormProps={editFormProps}
                    idResource={idSection}
                    modal={true}
                // closeModal={cerrarModal}
                ></Cw8Edit>
        </Modal>


    </>

  );
}